module.exports = __webpack_public_path__ + "img/icon-icon.6f07ef0c.svg";